var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kefuList"},[_c('div',{staticClass:"info-content"},[_c('div',{staticClass:"v-text",domProps:{"innerHTML":_vm._s(_vm.htmlData)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }